import romanApi, { type RomanApiError } from "@roman/shared/lib/net/romanApi";
import type { RoundEntryPrize } from "@roman/shared/types/RoundEntryPrize";
import { useEffect } from "react";
import useSWR from "swr";

type PrizePayoutResponse = {
  roundEntryPrize: RoundEntryPrize[];
};

const fetcher = (url: string) => romanApi.get<PrizePayoutResponse>(url, undefined);

export const usePrizePayout = (roundId: string, handleError: (err: RomanApiError) => void) => {
  const { data, error, isLoading } = useSWR<PrizePayoutResponse, RomanApiError>(`/prizes/${roundId}`, (url: string) =>
    fetcher(url),
  );

  useEffect(() => {
    if (error) {
      handleError(error);
    }
  }, [error, handleError]);

  return {
    data,
    isLoading,
  };
};
